<template>
  <div class="page-register">
    <div class="header">
      <header>
        <!-- <a href="#" ></a> -->
        <router-link class="site-logo" :to="{ name: 'index' }"></router-link>
        <div class="login">
          <span>已有美团账号？</span>
          <router-link :to="{ name: 'login' }">登录</router-link>
        </div>
      </header>
    </div>
    <div class="content">
      <el-form
        :model="registerForm"
        status-icon
        :rules="rules"
        ref="registerForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="用户名" prop="userName">
          <el-input
            type="text"
            v-model="registerForm.userName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            v-model="registerForm.password"
            autocomplete="off"
            @input="input"
          ></el-input>
          <div class="pw-strength">
            <div :class="['bar', strengthClass]"></div>
            <div class="letter">
              <span>弱</span>
              <span>中</span>
              <span>强</span>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="确认密码" prop="rePassword">
          <el-input
            type="password"
            v-model="registerForm.rePassword"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('registerForm')"
            >同意以下协议并注册</el-button
          >
        </el-form-item>
        <div class="term">
          <a
            class="f1"
            href="https://rules-center.meituan.com/rules-detail/4"
            target="_blank"
            >《美团用户服务协议》</a
          >
          <a
            class="f1"
            href="https://rules-center.meituan.com/rules-detail/2"
            target="_blank"
            >《美团隐私政策》</a
          >
        </div>
      </el-form>
    </div>
    <footer>
      <p>
        <a href="https://www.meituan.com">©meituan.com</a>&nbsp;
        <a href="http://www.miibeian.gov.cn/" target="_blank"
          >京ICP证070791号</a
        >
        京公网安备11010502025545号
      </p>
    </footer>
  </div>
</template>

<script>
import api from "@/api/index.js";

export default {
  data() {
    let validateUser = (rule, value, callback) => {
      // console.log(value);
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else if (value.length < 4 || value.length > 16) {
        callback(new Error("用户名必须为4-16位的字母数字下划线组成"));
      } else {
        callback();
      }
    };
    let validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error("密码必须为6-16位的字母数字或下划线组成"));
      } else {
        // if (this.registerForm.rePassword !== "") {
        //   this.$refs.registerForm.validateField("rePassword");
        // }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.registerForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      registerForm: {
        userName: "",
        password: "",
        rePassword: "", //确认密码
      },
      strengthClass: "", // 密码强度
      rules: {
        // 校验规则
        userName: [{ validator: validateUser, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        rePassword: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm(formName) {
      // 校验表单
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 通过
          api
            .register({
              params: this.registerForm,
            })
            .then((res) => {
              // 登录成功
              if (res.data.status === "success") {
                this.$router.push({ name: "login" });
              } else {
                // 登录失败
                alert(res.data.msg);
              }
            });
        } else {
          // 不通过
          // console.log("error submit!!");
          return false;
        }
      });
    },
    input() {
      let regStr = /(\w)+/g,
        regNum = /(\d)+/g,
        reg = /_/g,
        strongth =
          this.registerForm.password.match(reg) &&
          this.registerForm.password.match(regStr) &&
          this.registerForm.password.match(regNum);

      // console.log("abc123_".match(reg));
      if (
        this.registerForm.password.length > 11 ||
        (this.registerForm.password.length > 6 && strongth)
      ) {
        this.strengthClass = "strong";
      } else if (this.registerForm.password.length < 7) {
        this.strengthClass = "week";
      } else if (!this.registerForm.password) {
        this.strengthClass = "";
      } else {
        this.strengthClass = "normal";
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/css/register/index.scss";
</style>
